const getTimestamp = () => new Date().getTime();

const SOURCES = require('../utils/sources');

const getId = ({id} = {}) => id;

module.exports = class CartItem {
    constructor(state = {}) {
        const {committed = false, committable = false, source = {}, price = {}, extra = {}, category = '', toBeRestored = false} = state;
        const {action = SOURCES.actions.USER_REQUESTED, target = SOURCES.targets.UNKNOWN} = source;

        this.state = {
            ...state,
            committed,
            committable,
            source: {action, target},
            price,
            extra,
            toBeRestored: toBeRestored || category !== 'BAGGAGE',
        };

        this.updates = [];

        this.initTimestamps(getTimestamp());
    }

    initTimestamps(timestamp) {
        this.created = timestamp;
        this.updated = timestamp;
    }

    update(data = {}) {
        const {success = false, price = 0} = data;

        this.updates.push(data);
        this.state.committed = success;
        this.updated = getTimestamp();

        Object.assign(this.state.price, {total: price});
    }

    setToBeRestored(toBeRestored) {
        this.state.toBeRestored = toBeRestored;
        return this.state;
    }

    get committed() {
        return this.state.committed;
    }

    get data() {
        return Object.assign({}, this.state);
    }

    get id() {
        return getId(this.state);
    }

    forceCommit() {
        this.state.committed = false;
    }
};
